import { Button, Form, Input, message, Modal } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import css from './Pos.module.css';

const Stopwatch = ({ setKassaStatus }) => {
    const [elapsed, setElapsed] = useState(null); // null bo‘lsa, ko‘rsatmaymiz
    const [open, setOpen] = useState(false)

    useEffect(() => {
        const startTime = localStorage.getItem('start_time');

        if (!startTime) return; // start_time bo‘lmasa, hech nima ko‘rsatmaymiz

        const start = new Date(startTime).getTime();

        const updateElapsed = () => {
            const now = Date.now();
            const diffInSeconds = Math.floor((now - start) / 1000);
            setElapsed(diffInSeconds);
        };

        updateElapsed(); // dastlab darhol hisobla
        const interval = setInterval(updateElapsed, 1000); // har 1 sekundda yangilab tur

        return () => clearInterval(interval); // komponent unmount bo‘lsa, intervalni tozalash
    }, []);

    const formatTime = (totalSeconds) => {
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };

    // localStorage'da vaqt yo‘q bo‘lsa — komponent chiqmasin
    if (elapsed === null) return null;

    return (
        <>
            <Modal open={open} footer={null} onCancel={() => setOpen(false)}>
                <h3>Kassani aniq yopmoqchimisiz?</h3>
                <Form onFinish={(value) => {
                    axios.post('closeregister/' + localStorage.getItem('shop_id'), value).then(() => {
                        localStorage.removeItem('start_time')
                        localStorage.removeItem('shop_id')
                        setElapsed(null)
                        setKassaStatus(true)
                        setOpen(false)
                    }).catch(error => {
                        setKassaStatus(false)
                        message.error("Xatolik yuz berdi")
                        console.error("Xatolik:", error)
                    })
                }} layout='vertical' >
                    <Form.Item name={'end_cash'} label='Kassadagi qoldiq summani kiriting' rules={[{ required: true, message: 'Iltimos kassaga qoldiqni kiriting' }]}>
                        <Input type='number' />
                    </Form.Item>
                    <Form.Item>
                        <Button type='primary' htmlType='submit'>Yopish</Button>
                    </Form.Item>
                </Form>
            </Modal>
            <div className={css.timerWidget}>
                <span className={css.timerDot} />
                <div className={css.timerInner}>
                    <span className={css.timerLabel}>Smena vaqti</span>
                    <span className={css.timerValue}>{formatTime(elapsed)}</span>
                </div>
                <Button onClick={() => setOpen(true)} type="primary" danger>Reestrni yopish</Button>
            </div>
        </>
    );
};

export default Stopwatch;
